const ENTITY_MAP = {
    nbsp: ' ',
    '#160': ' ',
    '#xa0': ' ',
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    '#39': "'",
    ndash: '–',
    mdash: '—',
    laquo: '«',
    raquo: '»',
};

// Текстовые блоки являются plain text. Это ограниченный compatibility
// fallback для старых данных, а не общий HTML decoder.
export const normalizeTextBlockText = (value) => String(value ?? '').replace(
    /&(?:nbsp|amp|lt|gt|quot|apos|ndash|mdash|laquo|raquo|#160|#xA0|#0*39);/gi,
    entity => {
        let key = entity.slice(1, -1).toLowerCase();
        if (/^#0*39$/.test(key)) key = '#39';
        return ENTITY_MAP[key] ?? entity;
    }
);
